/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.layouts.membership.cards.create.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.service.themesHelper',
  'acme.common.service.userPreferences',
  'acme.common.factory.notice',
  'acme.view.application.layouts.membership.cards.deleteModal.controllers'
])

.controller('LayoutsMembershipCardsCreateController', ['$scope', '$state', '$uibModal', '$q', 'ApiService', 'ValidateService', 'HelpersService', 'NoticeFactory', 'UserPreferencesService', 'ThemesHelperService', 'ThemesData', function($scope, $state, $uibModal, $q, ApiService, ValidateService, HelpersService, NoticeFactory, UserPreferencesService, ThemesHelperService, ThemesData) {

    $scope.layoutsMembershipCardsCreate = {

      model: {
        name: '',
        description: '',
        cssText: '',
        htmlText: '',
        active: false,
        assigned: false
      },

      variables: [
        {
          label: 'Organization Name',
          name: '$membership.companyName',
          markup: "#if ($membership.companyName)\n\t$membership.companyName\n#end\n"
        },
        {
          label: 'Cardholder Name',
          name: '$membership.cardholderName',
          markup: "#if ($membership.cardholderName)\n\t$membership.cardholderName\n#end\n"
        },
        {
          label: 'Member Name',
          name: '$membership.memberName',
          markup: "#if ($membership.memberName)\n\t$membership.memberName\n#end\n"
        },
        {
          label: 'Customer Title',
          name: '$customer.title',
          markup: "#if ($customer.title)\n\t$customer.title\n#end\n"
        },
        {
          label: 'Customer First Name',
          name: '$customer.firstName',
          markup: "#if ($customer.firstName)\n\t$customer.firstName\n#end\n"
        },
        {
          label: 'Customer Last Name',
          name: '$customer.lastName',
          markup: "#if ($customer.lastName)\n\t$customer.lastName\n#end\n"
        },
        {
          label: 'Membership Level Name',
          name: '$membership.levelName',
          markup: "#if ($membership.levelName)\n\t$membership.levelName\n#end\n"
        },
        {
          label: 'Membership Offering Name',
          name: '$membership.offeringName',
          markup: "#if ($membership.offeringName)\n\t$membership.offeringName\n#end\n"
        },
        {
          label: 'Membership Price Point Name',
          name: '$membership.pricePointName',
          markup: "#if ($membership.pricePointName)\n\t$membership.pricePointName\n#end\n"
        },
        {
          label: 'Membership Join Date',
          name: '$membership.joinDate',
          markup: "#if ($membership.joinDate)\n\t$membership.joinDate\n#end\n"
        },
        {
          label: 'Membership Join Year',
          name: '$membership.joinYear',
          markup: "#if ($membership.joinYear)\n\t$membership.joinYear\n#end\n"
        },
        {
          label: 'Membership Expiration Date',
          name: '$membership.expirationDate',
          markup: "#if ($membership.expirationDate)\n\t$membership.expirationDate\n#end\n"
        },
        {
          label: 'Current Membership Term Start Date',
          name: '$membership.startDate',
          markup: "#if ($membership.startDate)\n\t$membership.startDate\n#end\n"
        },
        {
          label: 'ACME Membership ID',
          name: '$membership.id',
          markup: "#if ($membership.id)\n\t$membership.id\n#end\n"
        },
        {
          label: 'ACME Customer ID',
          name: '$membership.customerId',
          markup: "#if ($membership.customerId)\n\t$membership.customerId\n#end\n"
        },
        {
          label: 'ACME Barcode ID',
          name: '$membership.barcodeId',
          markup: "#if ($membership.barcodeId)\n\t$membership.barcodeId\n#end\n"
        },
        {
          label: 'External Customer ID',
          name: '$membership.externalCustomerId',
          markup: "#if ($membership.externalCustomerId)\n\t$membership.externalCustomerId\n#end\n"
        },
        {
          label: 'External Barcode ID',
          name: '$membership.externalBarcodeId',
          markup: "#if ($membership.externalBarcodeId)\n\t$membership.externalBarcodeId\n#end\n"
        },
        {
          label: 'Barcode',
          name: '$membership.qrImage',
          markup: '#if ($membership.qrImage)' + "\n\t" + '<img height="140" width="140" src="$baseUrl/v2/b2c/orders/qrcode/raw?height=140&width=140&data=$membership.barcodeId" alt="Membership Card"/>' + "\n#end\n"
        }
      ],

      initted: false,
      lastCaretPosition: 0,
      activeLayout: null,
      isEdit: false,
      showSaveTag: false,
      close: false,
      dateFormat: UserPreferencesService.getDateFormat('standardDate', 'dateFormat') + ' \'at\' ' +  UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
      deleteModal: {},
      validators: [],

      notice: new NoticeFactory(),

      init: function() {
        var self = $scope.layoutsMembershipCardsCreate;

        $scope.$emit('Application::contentTitleChange', {
          title: 'Membership Card Layout',
          buttonLeft: {
            label: 'Cancel',
            action: function() {
              $state.go('application.layouts.membership.cards.list');
            }
          },
          buttonRight: {
            label: 'Save and Close',
            action: function() {
              self.saveMembershipCard(true);
            }
          }
        });

        this.getActive();

        if (ThemesData && ThemesData.data.success) {
          ThemesHelperService.setModel(ThemesData.data.payload);
        }

        if ($state.params && $state.params.id) {
          self.isEdit = true;
          this.getMembershipCard($state.params.id);
        }else{
          this.replaceDefaultHTML();
          this.replaceDefaultCSS();
        }

        this.initValidators();

      },

      initValidators: function() {
        this.validators = [
          {
            field: 'layouts-membership-cards-create-header-name',
            len: {
              message: 'The configuration name must not be empty',
              test: function() {
                var self = $scope.layoutsMembershipCardsCreate;
                return {
                  value: self.model.name
                };
              }
            }
          }
        ];
      },

      getError: function(field) {
        return ValidateService.getError(field);
      },

      insert: function(variable) {

        var textarea = $('#layouts-membership-cards-create-form-html'),
            text = textarea.val(),
            insertText = variable + ' ';

        if (!this.initted && text.length && this.lastCaretPosition === 0) {
          this.lastCaretPosition = text.length - 1;
        }

        this.model.htmlText = text.substr(0, this.lastCaretPosition) + insertText + text.substr(this.lastCaretPosition, text.length);
        this.lastCaretPosition += insertText.length;
        HelpersService.setCaretPosition(textarea, this.lastCaretPosition);

      },

      saveCaret: function() {

        var textarea = $('#layouts-membership-cards-create-form-html');

        this.lastCaretPosition = HelpersService.getCaretPosition(textarea.get(0));
        this.initted = true;

      },

      getMembershipCard: function (id) {
        this.showSaveTag = false;
        ApiService.membership.cards.layouts.detail(id).then(this.success.getMembershipCard, this.error.getMembershipCard);
      },

      getActive: function() {
        var self = $scope.layoutsMembershipCardsList;
        ApiService.membership.cards.layouts.list({active: true}).then(this.success.getActive, this.error.getActive);
      },

      deleteMembershipCard: function () {
        var self = $scope.layoutsMembershipCardsCreate;
        self.showSaveTag = false;
        self.deleteModal = $uibModal.open({
          templateUrl: 'views/application/views/layouts/membership/cards/modals/delete.tpl.html',
          size: 'md',
          controller: 'LayoutsMembershipCardsDeleteModalController',
          resolve: {
            currentLayout: function() {
              return self.model;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.deleteModal.result.then(function () {
          ApiService.membership.cards.layouts.remove(self.model.id).then(self.success.deleteMembershipCard, self.error.deleteMembershipCard);
        }, function () {
          // Do nothing
        });
      },

      saveMembershipCard: function (close) {
        var self = $scope.layoutsMembershipCardsCreate;

        if (ValidateService.validate(self.validators)) {
          if (close) {
            self.close = true;
          }
          self.showSaveTag = false;
          if (self.isEdit) {
            ApiService.membership.cards.layouts.update(self.model).then(self.success.saveMembershipCard, self.error.saveMembershipCard);
          } else {
            ApiService.membership.cards.layouts.create(self.model).then(self.success.saveMembershipCard, self.error.saveMembershipCard);
          }
        }

      },

      publishLayout: function () {
        var self = $scope.layoutsMembershipCardsCreate;

        if (ValidateService.validate(self.validators)) {
          self.showSaveTag = false;
          if (self.isEdit) {
            ApiService.membership.cards.layouts.update(self.model, true).then(self.success.publishLayout, self.error.publishLayout);
          }
        }

      },

      activateLayout: function(id) {
        var self = $scope.layoutsMembershipCardsCreate;

        if (ValidateService.validate(self.validators)) {
          self.model.active = true;
          if (self.activeLayout) {
            self.activeLayout.active = false;
            $q.all(
              ApiService.membership.cards.layouts.update(self.model),
              ApiService.membership.cards.layouts.update(self.activeLayout)
            ).then(self.success.activateLayout, self.error.activateLayout);
          } else {
            ApiService.membership.cards.layouts.update(self.model).then(self.success.saveMembershipCard, self.error.saveMembershipCard);
          }
        }

      },

      replaceDefaultCSS: function () {
        this.model.cssText = ThemesHelperService.getMembershipConfig('membershipCardLayouts', 'cssText');
      },

      replaceDefaultHTML: function () {
        this.model.htmlText = ThemesHelperService.getMembershipConfig('membershipCardLayouts', 'htmlText');
      },

      success: {
        init: function(response) {},

        getMembershipCard : function(response) {
          var self = $scope.layoutsMembershipCardsCreate;
          self.model = response.data.payload;
        },

        getActive: function(response) {
          var self = $scope.layoutsMembershipCardsCreate;
          if (response.data.payload.list.length) {
            self.activeLayout = response.data.payload.list[0];
          }
        },

        publishLayout: function(response) {
          var self = $scope.layoutsMembershipCardsCreate;

          self.model = response.data.payload;
        },

        saveMembershipCard: function(response) {
          var self = $scope.layoutsMembershipCardsCreate;
          self.showSaveTag = true;

          if (self.close) {
            $state.go('application.layouts.membership.cards.list');
          } else {
            if (self.isEdit) {
              self.model = response.data.payload;
            }else {
              $state.go('application.layouts.membership.cards.edit', {id: response.data.payload.id});
            }
          }
        },

        activateLayout: function() {
          var self = $scope.layoutsMembershipCardsCreate;
          self.showSaveTag = true;
        },

        deleteMembershipCard: function(response) {
          $state.go('application.layouts.membership.cards.list');
        }
      },

      error: {
        init: function(response) {},
        getMembershipCard : function(response) {},
        getActive: function(){},
        publishLayout: function(response) {
          var self = $scope.layoutsMembershipCardsCreate;

          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        saveMembershipCard: function(response) {},
        deleteMembershipCard: function(response) {},
        activateLayout: function(response) {}
      }

    };

    $scope.layoutsMembershipCardsCreate.init();

}]);
